import React, { useState, useEffect, useRef} from 'react'
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import NewsCard from '../components/NewsCard';
import AlertOnLoading from '../components/AlertOnLoading';
import { collection, getDocs } from "firebase/firestore";
import { database } from "../config/firebaseConfig";

function News() {
  const WAIT_TIME = 1000; //Waits for 2s
  const notInitialRender = useRef(false);
  const [newData, setNewData] = useState(true);
  const [allNews, setAllNews] = useState(null);
  const [allNewsArranged, setAllNewsArranged] = useState(null);
  const [isSorted, setIsSorted] = useState(false);

  function order() {

    if (allNews) {
      const sorted = [...allNews].sort((a, b) => a.date < b.date ? 1 : -1);
      setAllNewsArranged(sorted);
    }

  }

  /*
  Gets all news documents
  */
  useEffect(() => {
    if (notInitialRender.current && newData) {
        AlertOnLoading(WAIT_TIME+100);
    } else {
        notInitialRender.current = true;
    } 
    const interval = setInterval(() => { //Autorize re-render
      if (newData) {
          const allNewsRef = collection(database, "news");
          
          const getNews = async() => {
              const data = await getDocs(allNewsRef);
              setAllNews(data.docs.map((doc) => ({...doc.data(), id: doc.id})));
          }
          console.log("Actualizo");
          getNews();
          setNewData(!newData);
          

      } else if (!isSorted) {
        order();
        setIsSorted(true);
      }

        }, WAIT_TIME);
        return () => clearInterval(interval);
  }, [allNews, newData])

  return (
    <div>
        
        <Navbar activePage={"/News"} />
        <div className='w-full h-navbar-mobile sm:h-navbar'></div>

        <div className='w-full h-96 bg-news-banner bg-white'>

          <div className='h-full w-full bg-gradient-radial from-primary-100'>
            <h2 className='text-white text-center py-44 text-3xl font-semibold sm:text-4xl'>Últimas actualizaciones</h2>  
          </div>
          
        </div>
        
        <NewsCard allNews={allNewsArranged}/>

        <Footer />
    </div>
  )
}

export default News